export default class CostService {
    static getCost(dpt: string): number {
        // @ts-ignore
        return costsByDepartment[dpt];
    }
}

/*const costsByDepartment =
    {
            '01': 4369,
            '02': 6329,
            '03': 3787,
            '04': 3507,
            '05': 3040,
            '06': 3620,
            '07': 3444,
            '08': 4943,
            '09': 3656,
            '10': 5084,
            '11': 3408,
            '12': 3613,
            '13': 3321,
            '14': 4015,
            '15': 3978,
            '16': 3500,
            '17': 4085,
            '18': 4708,
            '19': 3383,
            '20': 4423,
            '2A': 4423,
            '2B': 4423,
            '21': 3878,
            '22': 3697,
            '23': 4005,
            '24': 3703,
            '25': 4643,
            '26': 4443,
            '27': 4040,
            '28': 4351,
            '29': 3571,
            '30': 3706,
            '31': 3719,
            '32': 3766,
            '33': 3350,
            '34': 3490,
            '35': 3500,
            '36': 2930,
            '37': 3519,
            '38': 3465,
            '39': 3964,
            '40': 3396,
            '41': 4208,
            '42': 3283,
            '43': 3301,
            '44': 4338,
            '45': 4086,
            '46': 2736,
            '47': 3848,
            '48': 2844,
            '49': 4305,
            '50': 4874,
            '51': 4321,
            '52': 3945,
            '53': 3073,
            '54': 4468,
            '55': 5843,
            '56': 3322,
            '57': 3406,
            '58': 4523,
            '59': 4671,
            '60': 4724,
            '61': 4338,
            '62': 4303,
            '63': 4609,
            '64': 3504,
            '65': 3426,
            '66': 3585,
            '67': 3364,
            '68': 3174,
            '69': 3998,
            '70': 3710,
            '71': 3810,
            '72': 4240,
            '73': 3541,
            '74': 4115,
            '75': 4798,
            '76': 4429,
            '77': 4741,
            '78': 5618,
            '79': 3943,
            '80': 3946,
            '81': 3731,
            '82': 3608,
            '83': 3826,
            '84': 3239,
            '85': 4319,
            '86': 4063,
            '87': 3165,
            '88': 4668,
            '89': 3781,
            '90': 3628,
            '91': 4314,
            '92': 3182,
            '93': 6751,
            '94': 4200,
            '95': 5255,
            '971': 5170,
            '972': 3763,
            '973': 3770,
            '974': 2030,
            '975': 3770,
            '976': 3770
    };*/

const costsByDepartment =
{
    "01": 4864,
    "02": 4839,
    "03": 4611,
    "04": 4337,
    "05": 2935,
    "06": 4343,
    "07": 3977,
    "08": 4331,
    "09": 2796,
    "10": 4308,
    "11": 3745,
    "12": 4714,
    "13": 3547,
    "14": 5324,
    "15": 4513,
    "16": 3994,
    "17": 4261,
    "18": 4559,
    "19": 3944,
    "20": 4587,
    "2A": 4587,
    "2B": 4587,
    "21": 1700,
    "22": 4863,
    "23": 3738,
    "24": 4305,
    "25": 4597,
    "26": 4584,
    "27": 4239,
    "28": 3854,
    "29": 4181,
    "30": 3803,
    "31": 3863,
    "32": 3602,
    "33": 4465,
    "34": 3741,
    "35": 5305,
    "36": 5050,
    "37": 4262,
    "38": 3669,
    "39": 4799,
    "40": 3775,
    "41": 3689,
    "42": 3424,
    "43": 3513,
    "44": 5559,
    "45": 4677,
    "46": 4052,
    "47": 3860,
    "48": 4223,
    "49": 4693,
    "50": 4798,
    "51": 4471,
    "52": 4238,
    "53": 5604,
    "54": 3983,
    "55": 5387,
    "56": 3441,
    "57": 4671,
    "58": 4165,
    "59": 4648,
    "60": 4935,
    "61": 6750,
    "62": 4521,
    "63": 4221,
    "64": 3857,
    "65": 3828,
    "66": 4312,
    "67": 4307,
    "68": 5191,
    "69": 4711,
    "70": 5337,
    "71": 4726,
    "72": 5502,
    "73": 4050,
    "74": 5394,
    "75": 5027,
    "76": 5555,
    "77": 5127,
    "78": 5399,
    "79": 4096,
    "80": 5007,
    "81": 3885,
    "82": 4709,
    "83": 4435,
    "84": 3737,
    "85": 4575,
    "86": 5349,
    "87": 3717,
    "88": 4468,
    "89": 4918,
    "90": 4678,
    "91": 5472,
    "92": 5839,
    "93": 4982,
    "94": 4556,
    "95": 5228,
    "971": 4166,
    "972": 4255,
    "973": 4255,
    "974": 2142,
    "975": 4255,
    "976": 4255
};
